module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre3",
    attrs: {
      "id": "calibre_pb_0"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "p_heading_",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', {
    staticClass: "calibre1"
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "p_norm-noindent"
  }, [_c('span', {
    staticClass: "calibre4"
  }, [_vm._v("SPECIAL THANKS")]), _vm._v(" to F.E. Feeley Jr. for writing a song for me!")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("And of course to Noah Willoughby, Chris Scully, C.L. Miles, and Angelia Sparrow for your unbelievable help with research.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Thanks to Andi Byassee, which really goes without saying. I don’t know what I would do if I didn’t have her at my back. Especially with "), _c('span', {
    staticClass: "calibre2"
  }, [_vm._v("Blue")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Thanks also to Brian Holliday. I mean it, man. Thank you.")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("Tippy! Thank you so much! You saved me, man. Wow!")]), _vm._v(" "), _c('p', {
    staticClass: "p_normal"
  }, [_vm._v("And most especially to Lynn. Who saved this book.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-98b7042e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OPS/section0003.vue
// module id = 63
// module chunks = 0